/**
 * ConvertTimeTo24Hour
 *
 * Converts a given time into the 24 hour format
 *
 * @return {function}
 */

OT.createNS('OT.Search.Helpers.convertTimeTo24Hour');

OT.Search.Helpers.convertTimeTo24Hour = function(time) {

    var timeOfDay = time.match(/AM|PM|a.m.|p.m./i);
    
    if(timeOfDay !== null) {
        timeOfDay = timeOfDay[0];
        time = time.replace(/ AM| PM| a.m.| p.m./i, '').split(':');

        if((timeOfDay === 'AM' || timeOfDay === 'a.m.') && time[0] === '12') {
            time[0] = '00';
        }
        if((timeOfDay === 'PM' || timeOfDay === 'p.m.') && parseInt(time[0], 10) < 12) {
            time[0] = parseInt(time[0], 10) + 12;
        }

        time = time.join(':');
    }
    
    return time;

};